<script lang="ts">
    let yearNow = new Date().getFullYear()
</script>

<footer class="text-white text-center">
    <p>© Generator składów 2021 - {yearNow}<!-- Made by <a href="https://marcin.czop.ru">MrTalon63</a>--></p>
</footer>
